import { useState } from "react"
import { EComboItemType } from "../../Enum/EComboItemType"
import { ComboEntity } from "../../Objects/Combo/ComboEntity"
import { ComboItemReference } from "../../Objects/Combo/ComboItemReference"
import { GenericFoodEntity } from "../../Objects/MealsAndDrinks/GenericFoodEntity"

export const useCreateCombo = () => {
  const [combo, setCombo] = useState<ComboEntity | null>(null)

  const [items, setItems] = useState<ComboItemReference[]>([])

  const handleInitialValue = (data?: ComboEntity) => {
    if (data) {
      setCombo(data)
      
      setItems(data.items.map((item) => new ComboItemReference(item)))

      return
    }

    setCombo(null)

    setItems([])
  }

  const addMealItem = (id: number) => {
    setItems((prev) => [...prev, new ComboItemReference({ itemId: id, itemType: EComboItemType.Meal, quantity: 1 })])
  }

  const addDrinkItem = (id: number) => {
    setItems((prev) => [...prev, new ComboItemReference({ itemId: id, itemType: EComboItemType.Drink, quantity: 1 })])
  }

  const removeItem = (index: number) => setItems((prev) => prev.filter((_, i) => i !== index))

  const updateQuantity = (index: number, quantity: number) => {
    setItems((prev) => prev.map((item, i) => (i === index ? new ComboItemReference({ ...item, quantity }) : item)))
  }

  const handleSubmitForm = (genericFoodEntity: GenericFoodEntity) =>
    new ComboEntity({
      id: combo?.id,
      mealId: combo?.mealId,
      genericFoodEntity,
      items,
    })

  return { items, addMealItem, addDrinkItem, removeItem, updateQuantity, handleInitialValue, handleSubmitForm }
}
